import { createSelector } from 'reselect';

const stateSelector = state => state.login;

export const fetchingSelector = createSelector(stateSelector, state => state.fetching);
export const isAuthenticateSelector = createSelector(stateSelector, state => state.isAuthenticate);
export const isPinCodeModalOpenSelector = createSelector(stateSelector, state => state.isPinCodeModalOpen);
export const twoFAuthInfoSelector = createSelector(stateSelector, state => state.twoFAuthInfo);
export const isPasswordWeakSelector = createSelector(stateSelector, state => state.isPasswordWeak);
export const authMethodsSelector = createSelector(stateSelector, state => state.authMethods);
export const isBridgeSsoPendingSelector = createSelector(stateSelector, state => state.isBridgeSsoPending);
